import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SubSink } from 'subsink';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { BehaviorSubject } from 'rxjs';
import { AutoUnsubscribe } from './auto-unsubscribe';
import { DateAdapter } from '@angular/material/core';

@AutoUnsubscribe()
@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  subs = new SubSink();

  // TODO: maybe get this from backend?
  //       could be company specific so german customers wont see french UI etc
  supportedLanguages: UiLanguage[] = [
    {
      lang: 'de',
      flagIso2: 'de',
      culture: 'de-CH',
      name: _('LANGUAGE.DE.NAME'),
    },
    // {
    //     lang: 'en',
    //     flagIso2: 'gb',
    //     culture: 'en-GB',
    //     name: _('LANGUAGE.EN.NAME'),
    // },
  ];

  currentLanguage = new BehaviorSubject<UiLanguage>(this.supportedLanguages[0]);

  constructor(
    private translateService: TranslateService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.subs.sink = this.translateService.onLangChange.subscribe(s => {
      this.currentLanguage.next(
        this.supportedLanguages.find(
          f => f.lang.toLowerCase() == s.lang.toLowerCase()
        ) ?? this.supportedLanguages[0]
      );
    });
  }

  usePreferredLanguage(): void {
    const browserLang = this.translateService.getBrowserLang() ?? '';

    const preferredLang =
      this.supportedLanguages.find(
        f => f.lang.toLowerCase() == browserLang.toLowerCase()
      ) ?? this.supportedLanguages[0];

    this.translateService.use(preferredLang.lang);
    this.dateAdapter.setLocale(preferredLang.lang);
    this.notifyAjs(preferredLang.lang);
  }

  use(lang: string): void {
    this.translateService.use(lang);
    this.dateAdapter.setLocale(lang);
    this.notifyAjs(lang);
  }

  notifyAjs(lang?: string) {
    if (window.frames.length > 0) {
      window.frames[0].postMessage(
        {
          channel: 'ChangeLanguage',
          message: lang ?? this.currentLanguage.value?.lang,
        },
        '*'
      );
    }
  }
}

export interface UiLanguage {
  lang: string;
  flagIso2: string;
  name: string;
  culture: string;
}
